<template>
  <v-container class="pa-0">
    <v-layout v-if="loading">
      <v-flex offset-xs5 pa-5>
        <v-progress-circular :size="100" :width="5" color="primary" indeterminate></v-progress-circular>
      </v-flex>
    </v-layout>
    <v-layout row wrap v-else>
      <v-flex xs6 class="text-xs-center">
        <v-card height="715" class="pt-2 px-2 mr-1" color="grey lighten-4">
          <TwitterElement :link="twitter"></TwitterElement>
        </v-card>
      </v-flex>
      <v-flex xs6 class="text-xs-center">
        <v-card height="715" class="pt-2 px-2 ml-1" color="grey lighten-4">
          <FacebookElement :link="facebook"></FacebookElement>
        </v-card>
      </v-flex>
      <v-flex xs12>
        <v-card height="600" class="text-xs-center mt-2" color="grey lighten-4">
          <YoutubeElement :link="youtube"></YoutubeElement>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import TwitterElement from './TwitterElement'
import FacebookElement from './FacebookElement'
import YoutubeElement from './YoutubeElement'

const TWITTER_URL = 'https://twitter.com/LigaAFA'
const FACEBOOK_URL = 'https://www.facebook.com/ligaprofesionalAFA/'
const YOUTUBE_URL = 'https://www.youtube.com/embed/videoseries?list=UUJmCVoUfCBQb9lcfXIS8nXQ'

export default {
  components: {
    TwitterElement,
    FacebookElement,
    YoutubeElement
  },

  data () {
    return {
      loading: true,
      facebook: FACEBOOK_URL,
      twitter: TWITTER_URL,
      youtube: YOUTUBE_URL
    }
  },

  methods: {
    fetchData () {
      this.axios
        .get('ficha/social-networks')
        .then((response) => {
          this.twitter = response.data.twitter || this.twitter
          this.facebook = response.data.facebook || this.facebook
          this.youtube = this.getYoutubeLink(response.data.youtube) || this.youtube
          this.loading = false
        })
        .catch(error => {
          if (error && error.response && error.response.status === 404) {
            this.loading = false
          } else {
            this.$store.commit('setErrorMsg', error)
          }
        })
    },
    getYoutubeLink (link) {
      let channel = link.split('/').filter(element => element.length).slice(-1)[0]
      if (channel[0] === 'U') {
        channel = 'UU' + channel.substring(2, channel.length)
        return `https://www.youtube.com/embed/videoseries?list=${channel}`
      }
      return `https://www.youtube.com/embed/?listType=user_uploads&list=${channel}`
    }
  },

  mounted () {
    if (this.$store.getters.isClubRole) this.fetchData()
    if (this.$store.getters.isSafRole) { this.loading = false }
  }
}
</script>
